import moment from 'moment'
import Vue from 'vue'

import {
  SET_TOKEN,
  SET_REFRESH_TOKEN,
  TRIGGER_EVENT,
  SET_NOTIFICATION,
  SET_SETTING,
  // LIST_CLIENTS_REQ,
  GET_ME_REQ,
  GET_LOOKUPS_REQ,
  LIST_APPOINTMENTS_IN_RANGE_REQ,
  LIST_INVOICES_IN_RANGE_REQ,
  SET_ACTIVE_APPOINTMENT,
  SET_ACTIVE_DIALOG,
  SET_ACTIVE_DATE_RANGE,
  SET_SPACE_VALUE,
  SET_SPACE,
  HIDE_SPACE,
  ACTIVATE_RANGE_PICKER,
  // actions:
  INIT,
  SHOW_APPOINTMENT_DIALOG,
  LOGIN,
  LOGOUT,
  SET_POST_LOGIN_REDIRECT,
  KONG_TOKEN_KEY
} from '@/store/constants'

// const TOKEN_KEY = 'appointmentguru_practitioner_token'

export default {
  state: {
    token: null,
    refreshToken: null,
    isLoggedIn: false,
    channel: null,
    loginRedirect: '/',
    pageLoading: false,
    loginChallenge: 0,
    logoutRequest: 0,
    notification: {},
    tutorialLink: 'https://appointmentguru-co.appointmentguru.workers.dev/en/support-docs/grid-view/how-does-appointmentguru-work',
    activeDateRange: {
      from: moment.min(
        moment().startOf('month'),
        moment().subtract('2', 'days')).format('YYYY-MM-DD'),
      to: moment.max(
        moment().endOf('month'),
        moment().add('7', 'days')).format('YYYY-MM-DD')
    },
    calendarDate: null,
    globalSettings: {
      // appointment start / end
      startTime: null,
      endTime: null,
      activeDate: null,
      activeProduct: {},
      activePractitioner: null
    },
    spaces: {
      globalDialog: {
        title: null,
        component: null,
        options: {},
        actions: {},
        visible: false,
        fullscreen: true
      },
      secondaryGlobalDialog: {
        title: null,
        component: null,
        options: {},
        actions: {},
        visible: false,
        fullscreen: false
      }
    },
    triggers: {
      selectDateRange: Math.random()
    },
    ignoredAppointmentStatuses: ['c'],
    activeDialog: '',
    activateRangePicker: 0,
    activeAppointment: {},
    activeAppointmentTab: 'Reschedule',
    me: {},
    selectedAppointments: [],
    appointments: [],
    clients: [],
    globalEventInformation: {}
  },
  mutations: {
    'SET_TUTORIAL' (state, link) {
      state.tutorialLink = link
    },
    'LOGIN_CHALLENGE' (state) {
      state.loginChallenge++
    },
    'LOGOUT_REQUEST' (state) {
      state.logoutRequest++
    },
    'SET_LOGGEDIN' (state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },
    [SET_TOKEN] (state, token) {
      // window.localStorage.setItem(KONG_TOKEN_KEY, token)
      state.token = token
    },
    [SET_REFRESH_TOKEN] (state, token) {
      // window.localStorage.setItem(`${KONG_TOKEN_KEY}-refresh`, token)
      state.refreshToken = token
    },
    [TRIGGER_EVENT] (state, args) {
      state.triggers[args[0]] = Math.random()
    },
    [SET_SETTING] (state, settings) {
      if (settings.length === 2) {
        let key = settings[0]
        let value = settings[1]
        if (state.globalSettings[key] !== value) { // only apply setting if new
          Vue.set(state.globalSettings, key, value)
        }
      }
    },
    [SET_NOTIFICATION] (state, messageObject) {
      state.notification = messageObject
    },
    [SET_POST_LOGIN_REDIRECT] (state, redirect) {
      state.loginRedirect = redirect
    },
    [SET_ACTIVE_APPOINTMENT] (state, appointment) {
      state.activeAppointment = appointment
    },
    [SET_ACTIVE_DIALOG] (state, id) {
      state.activeDialog = id
    },
    [SET_ACTIVE_DATE_RANGE] (state, args) {
      state.activeDateRange.from = args[0]
      state.activeDateRange.to = args[1]
    },
    [ACTIVATE_RANGE_PICKER] (state, value) {
      state.activateRangePicker = value
    },
    [SET_SPACE_VALUE] (state, spaceKeyValue) {
      // e.g.: commit(SET_SPACE_VALUE, ['globalDialog', 'component', 'SomeComponent, isFullScreen])
      if (Array.isArray(spaceKeyValue)) {
        let space = spaceKeyValue[0]
        let key = spaceKeyValue[1]
        let val = spaceKeyValue[2]
        Vue.set(state.spaces[space], key, val)
      } else {
        Vue.set(state.spaces, spaceKeyValue.space, spaceKeyValue)
      }
    },
    setCalendarDate (state, date) {
      state.calendarDate = date
    },
    globalEvent (state, {componentName, data}) {
      let touch = Math.random()
      Vue.set(state.globalEventInformation, componentName, {touch, data})
    },
    setGlobalSelectedAppointments (state, val) {
      Vue.set(state, 'selectedAppointments', val)
    },
    toggleGloballySelectedAppointment (state, appointment) {
      if (appointment && appointment.id) {
        let selectedIndex = state.selectedAppointments.findIndex((appt) => {
          return parseInt(appt.id) === parseInt(appointment.id)
        })
        let isSelected = selectedIndex > -1
        if (isSelected) {
          state.selectedAppointments.splice(selectedIndex, 1)
        } else {
          state.selectedAppointments.push(appointment)
        }
      } else {
        console.error('toggleGloballySelectedAppointment must be passed an appointment object')
      }
    }
  },
  actions: {
    [INIT] ({commit, dispatch}) {
      // dispatch(LOGIN)
      let token = Vue.$cookies.get(KONG_TOKEN_KEY)
      if (!token) {
        token = window.localStorage.getItem(KONG_TOKEN_KEY)
      }
      let refreshToken = window.localStorage.getItem(`${KONG_TOKEN_KEY}-refresh`)

      if (token) {
        let payload = {
          access_token: token,
          refresh_token: refreshToken
        }
        dispatch(LOGIN, payload)
      }
    },
    // [LOGIN] ({commit}) {
      // let token = 'eb3dfa57890d51b469e060d47e85c381e608beef'
      // commit('SET_TOKEN', token)
      // commit('BACKEND_CONFIG_SET_HEADER', ['appointmentguru', 'Authorization', 'token ' + token])
    // },
    CLEAR_STORAGE () {
      let domain = 'appointmentguru.co'
      if (process.env.NODE_ENV === 'development') { domain = 'docker.localhost' }
      Vue.$cookies.remove(KONG_TOKEN_KEY, null, domain)
      window.localStorage.removeItem(KONG_TOKEN_KEY)
      window.localStorage.removeItem('appointmentguru_practitioner_token')
      window.localStorage.removeItem(`${KONG_TOKEN_KEY}-refresh`)
    },
    [LOGIN] ({commit, dispatch}, payload) {
      let token = payload.access_token
      let refreshToken = payload.refresh_token
      dispatch(LOGOUT)
      commit('SET_TOKEN', token)
      commit('SET_REFRESH_TOKEN', refreshToken)
      commit('BACKEND_CONFIG_SET_HEADER', ['appointmentguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['metadataguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['invoiceguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['authenticationguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['medicalaidguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['communicationguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['codeguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['subscriptionguru', 'Authorization', 'Bearer ' + token])
      // window.localStorage.setItem(KONG_TOKEN_KEY, token)
      // let domain = 'appointmentguru.co'
      // let secure = true
      // if (process.env.NODE_ENV === 'development') {
      //   domain = 'docker.localhost'
      //   secure = false
      // }
      // Vue.$cookies.set(KONG_TOKEN_KEY, token, '24d', null, domain, secure)
      dispatch('CLEAR_STORAGE')
      commit('SET_LOGGEDIN', true)
    },
    [LOGOUT] ({commit, dispatch}) {
      let token = null
      commit('SET_TOKEN', token)
      window.localStorage.clear()
      commit('SET_TOKEN', token)
      commit('SET_REFRESH_TOKEN', token)
      commit('BACKEND_CONFIG_SET_HEADER', ['appointmentguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['metadataguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['invoiceguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['authenticationguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['medicalaidguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['communicationguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['codeguru', 'Authorization', 'Bearer ' + token])
      commit('BACKEND_CONFIG_SET_HEADER', ['subscriptionguru', 'Authorization', 'Bearer ' + token])
      commit('clearClients')
      dispatch('CLEAR_STORAGE')
      commit('SET_LOGGEDIN', false)
    },
    [SHOW_APPOINTMENT_DIALOG] ({commit}, args) {
      let visible = args[0]
      let id = args[1]
      let appointment = args[2]
      // if (args.length > 3) {
      //   let options = args[3]
      // }

      if (visible === false) {
        commit(SET_ACTIVE_DIALOG, null)
      } else {
        commit(SET_ACTIVE_DIALOG, id)
        commit(SET_ACTIVE_APPOINTMENT, appointment)
      }
    },
    [ACTIVATE_RANGE_PICKER] ({commit}) {
      commit(ACTIVATE_RANGE_PICKER, Math.random())
    },
    [HIDE_SPACE] ({commit}, space) {
      commit('SET_SPACE_VALUE', [space, 'visible', false])
    },
    [SET_SPACE] ({commit}, args) {
      // usage: dispatch('SET_SPACE', ['globalDialog', 'component', options, actions, fullscreen] )
      let space = args[0]
      let component = args[1]
      let title = args[2]
      let options = args[3]
      let actions = args[4]

      let isFullScreen = true
      if (args.length === 6) {
        isFullScreen = args[5]
      }
      let settings = {
        space, component, title, options, actions, visible: true, fullscreen: isFullScreen
      }
      commit('SET_SPACE_VALUE', settings)
      // commit('SET_SPACE_VALUE', [space, 'fullscreen', isFullScreen])
      // commit('SET_SPACE_VALUE', [space, 'component', component])
      // commit('SET_SPACE_VALUE', [space, 'title', title])
      // commit('SET_SPACE_VALUE', [space, 'options', options])
      // commit('SET_SPACE_VALUE', [space, 'actions', actions])
      // commit('SET_SPACE_VALUE', [space, 'visible', true])
    },
    fetchAppointments ({commit}) {
    }
  },
  getters: {
    loginChallengeCount (state) {
      return state.loginChallenge
    },
    logoutRequestCount (state) {
      return state.logoutRequest
    },
    isLoggedIn (state, getters) {
      return state.isLoggedIn && getters.token
    },
    getRequestData: (state, getters) => (id, defaultResult) => {
      let req = getters.getRequestById(id)
      if (req &&
          req !== -1 &&
          req.result &&
          req.result.data) {
        return req.result.data
      }
      return defaultResult
    },
    getTutorial (state) {
      return state.tutorialLink
    },
    token (state) {
      return state.token
    },
    refreshToken (state) {
      return state.refreshToken
    },
    pageLoading (state) {
      return state.pageLoading
    },
    loginRedirect (state) {
      return state.loginRedirect
    },
    settings (state, getters) {
      let settings = state.globalSettings
      let me = getters.me
      if (me && me.profile) {
        settings['currency'] = me.profile.currency
        settings['timezone'] = me.profile.timezone
        settings['free_trial_expiry_date'] = me.profile.free_trial_expiry_date
      }
      return settings
    },
    globalCalendarDate (state) {
      return state.calendarDate
    },
    activeDateRange (state) {
      return state.activeDateRange
    },
    me (state, getters) {
      let result = getters.getRequestData(GET_ME_REQ, {})
      if (result && result.results && result.results.length > 0) {
        return result.results[0]
      }
      return {}
    },
    meId (state, getters) {
      let me = getters.me
      if (me) { return me.id }
      return null
    },
    isAdmin (state, getters) {
      return getters.me.is_admin
    },
    isReadOnly (state, getters) {
      let me = getters.me
      if (getters.businesses.length > 0 && getters.activeBusinesses.length === 0) { return true }
      if (me && me.profile && me.profile.is_active === false) {
        return true
      }
      return false
    },
    services (state, getters) {
      let me = getters.me
      if (me && me.profile && me.profile.services) {
        return me.profile.services
      }
      return []
    },
    appointments (state, getters) {
      return getters.getRequestData(LIST_APPOINTMENTS_IN_RANGE_REQ, [])
    },
    activeAppointments (state, getters) {
      return getters.appointments.filter((appt) => {
        return (state
                  .ignoredAppointmentStatuses
                  .indexOf(appt.status.toLowerCase()) === -1)
      })
    },
    appointmentsNeedingAttention (state, getters) {
      return getters.appointments.filter((appt) => {
        return (
          appt.status.toLowerCase() === 'n' &&
          appt.invoiceable === false
        )
      })
    },
    invoices (state, getters) {
      let data = getters.getRequestData(LIST_INVOICES_IN_RANGE_REQ, [])
      if (data && data.results) {
        return data.results
      }
      return []
    },
    getInvoicesByStatus: (state, getters) => (status) => { // heh .. that's a lot of nested functions
      if (getters.invoices) {
        return getters.invoices.filter((invoice) => {
          return invoice.status === status
        })
      }
      return []
    },
    clientsInRange (state, getters) {
      let clients = []
      let appointmentsByClient = {}

      let addPriceDetails = (li, appt) => {
        if (appt.price) {
          let price = parseFloat(appt.price)
          if (appt.status === 'P') {
            li.totalPaid += price
          } else {
            li.totalOwed += price
          }
        }
      }

      getters.appointments
        .map(function (appt) {
          if (clients.indexOf(appt.client) === -1) {
            clients.push(appt.client)
          }
          try {
            appointmentsByClient[appt.client].push(appt)
            addPriceDetails(appointmentsByClient[appt.client], appt)
          } catch (e) {
            appointmentsByClient[appt.client] = []
            appointmentsByClient[appt.client].push(appt)
            appointmentsByClient[appt.client].totalOwed = 0
            appointmentsByClient[appt.client].totalPaid = 0
            addPriceDetails(appointmentsByClient[appt.client], appt)
          }
        })
      return {
        clients: clients,
        appointmentsByClient: appointmentsByClient
      }
    },
    lookups (state, getters) {
      let res = getters.getRequestById(GET_LOOKUPS_REQ, true)
      let lookups = null
      if (res && res.result && res.result.data) { lookups = res.result.data }
      if (lookups) { return lookups }
      return {}
    },
    businesses (state, getters) {
      if (getters.lookups && getters.lookups.businesses) {
        return getters.lookups.businesses
      }
      return []
    },
    activeBusinesses (state, getters) {
      if (getters.businesses) {
        return getters.businesses.filter((biz) => { return biz.is_active })
      }
      return []
    },
    locationsBySpace: (state, getters) => (spaceId) => {
      // fetch from looksups
      if (getters.lookups && getters.lookups.spaces && (spaceId in getters.lookups.spaces)) {
        return Object.values(getters.lookups.spaces[spaceId].locations)
      }
      return null
    },
    products (state, getters) {
      // fetch from looksups
      if (getters.lookups && getters.lookups.products) {
        return Object.values(getters.lookups.products)
      }
      return []
    },
    spaces (state, getters) {
      // fetch from looksups
      if (getters.lookups && getters.lookups.spaces) {
        return Object.values(getters.lookups.spaces)
      }
      // legacy: fetch from me:
      return getters.services.map((space) => {
        let logo = null
        // let random = Math.round(Math.random(0, 100) * 100)
        // let icon = `https://randomuser.me/api/portraits/women/${random}.jpg`
        if (space.logo_picture) {
          logo = space.logo_picture
        }
        return {
          title: space.title,
          id: space.id,
          logo_picture: logo
        }
      })
    },
    getIntegration: (state, getters) => (integrationName, spaceId) => {
      if (getters.lookups && getters.lookups.integrations) {
        return getters.lookups.integrations.find((integration) => {
          // console.log(integration.title, integrationName)
          if (spaceId) {
            return (integration.title === integrationName && (parseInt(integration.space) === parseInt(spaceId)))
          } else {
            return integration.title === integrationName
          }
        })
      }
      return null
    },
    getAppointmentById: (state) => (id) => {
      if (id in state.appointments.objects) {
        return state.appointments.objects
      }
      return null
    },
    getSpaceById: (state, getters) => (id) => {
      if (getters.lookups && getters.lookups.spaces && id in getters.lookups.spaces) {
        return getters.lookups.spaces[id]
      }
      return null
    },
    getSpacesByPractitionerId: (state, getters) => (practitionerId) => {
      let spaces = getters.lookups.spaces
      if (spaces) {
        return Object.values(spaces).filter((space) => {
          return (space.members.indexOf(practitionerId) !== -1 && space.membership_active !== false)
        })
      }
      return []
    },
    getProductsBySpaceAndPractitionerId: (state, getters) => (practitionerId, spaceId) => {
      let products = getters.lookups.products
      return products.filter((product) => {
        let isProductOwner = (String(product.owner === String(practitionerId)))
        let isInSpace = (String(product.space) === String(spaceId))
        return isProductOwner && isInSpace
      })
    },
    getProducts: (state, getters) => (practitionerId, spaceId, locationId) => {
      let products = getters.lookups.products
      if (products) {
        let productList = Object.values(products)
        return productList.filter((product) => {
          let isProductOwner = true
          let isInSpace = true
          let isInLocation = true
          if (product.archived === true) { return false }
          if (practitionerId) {
            isProductOwner = (String(product.owner) === String(practitionerId))
          }
          if (spaceId) {
            isInSpace = (String(product.space) === String(spaceId))
          }
          if (locationId) {
            if (product.locations) {
              isInLocation = product.locationIds.indexOf(locationId) !== -1
            } else {
              isInLocation = false
            }
          }
          return isProductOwner && isInSpace && isInLocation
        })
      }
      return []
    },
    getProductById: (state, getters) => (id) => {
      if (getters.lookups && getters.lookups.products && id in getters.lookups.products) {
        return getters.lookups.products[id]
      }
      return null
    },
    getLocations (state, getters) {
      if (getters.lookups && getters.lookups.locations && getters.lookups.locations.length > 0) {
        return getters.lookups.locations
      }
      return []
    },
    getLocationsBySpaceId: (state, getters) => (spaceId, showArchived) => {
      return getters.getLocations.filter((loc) => {
        if (loc.spaces) {
          return loc.spaces.indexOf(spaceId) >= 0
        }
        return false
      })
    },
    getLocationById: (state, getters) => (id) => {
      return getters.getLocations.find((loc) => {
        return loc.id === id
      })
    },
    getSharedCalendars (state, getters) {
      return getters.lookups.shared_calendars || []
    },
    getColleagues (state, getters) {
      return getters.lookups.practitioners || []
    },
    getPractitionerById: (state, getters) => (id) => {
      if (getters.lookups && getters.lookups.practitioners && id in getters.lookups.practitioners) {
        return getters.lookups.practitioners[id]
      }
      return {}
    },
    getGlobalDialogEvent: (state, getters) => (dialogId) => {
      if (dialogId in state.globalEventInformation) {
        return state.globalEventInformation[dialogId]
      }
      return {data: {}, touch: 0}
    }
    // clients (state, getters) {
    //   return getters
    //           .getRequestData(LIST_CLIENTS_REQ, {})
    //             .results || []
    // }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/application.js